import { render } from "./WinningAgency.vue?vue&type=template&id=642d8625&scoped=true"
import script from "./WinningAgency.vue?vue&type=script&lang=js"
export * from "./WinningAgency.vue?vue&type=script&lang=js"

import "./WinningAgency.vue?vue&type=style&index=0&id=642d8625&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642d8625"]])

export default __exports__